var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.close,
          expression: "close"
        }
      ],
      staticClass: "listing-select"
    },
    [
      _c("preloader", { attrs: { display: _vm.loading, size: "small" } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "selectedLabel p-2 flex-level",
          class: { cpointer: _vm.route && _vm.permission },
          on: { click: _vm.openDropdown }
        },
        [
          _c("chip-label", {
            attrs: { color: _vm.selected.color, label: _vm.selected.label }
          }),
          _vm._v(" "),
          _vm.route && _vm.permission
            ? _c("i", {
                staticClass: "el-icon-arrow-down gray-60 ml-2 flex-item-right"
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.open
        ? _c(
            "ul",
            {
              staticClass:
                "itemsSelector pabsolute top-left zi-1 mw-100pc b-0 shadow white-bkg m-0 px-0"
            },
            [
              _c(
                "li",
                {
                  staticClass: "selectedItem py-2 cpointer bb-1 flex-level",
                  on: { click: _vm.close }
                },
                [
                  _c("chip-label", {
                    attrs: {
                      color: _vm.selected.color,
                      label: _vm.selected.label
                    }
                  }),
                  _vm._v(" "),
                  _vm.route
                    ? _c("i", {
                        staticClass:
                          "el-icon-arrow-up gray-60 flex-item-right ml-2"
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.availableItems, function(item) {
                return _c(
                  "li",
                  {
                    key: item.id,
                    staticClass: "py-2 cpointer flex-level",
                    on: {
                      click: function($event) {
                        return _vm.setSelected(item)
                      }
                    }
                  },
                  [
                    _c("chip-label", {
                      attrs: { color: item.color, label: item.label }
                    })
                  ],
                  1
                )
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }